export const COMMON_AUDIO_EXTENSIONS = ['m4a', 'mp3', 'ogg', 'aac', 'aiff', 'wav'];
